import { get } from 'lodash';

import quartersDict from '../../../enums/deadline-quarter';
import materialTypeDict from '../../../enums/material-type';

import template from './short-mode-object-preview.jade';
import { getUndergroundDistance } from '../../../services/geo.service';

export default angular
  .module('cian.addForm.AddressShortModeObjectPreview', [])
  // eslint-disable-next-line func-names
  .directive('cianAfAddressShortModeObjectPreview', [function () {
    return {
      scope: {},
      controller: ['addFormService', 'addFormLayoutService', 'apiService', '$q', 'jkService', 'coworkingService', '$rootScope',
      // eslint-disable-next-line func-names
      function (addFormService, addFormLayoutService, apiService, $q, jkService, coworkingService) {
        this.layoutService = addFormLayoutService;
        this.ad = addFormService.ad;

        const isBsCenterMode = addFormLayoutService.shortLayoutMode === 'bsCenter';

        this.isCoworking = addFormLayoutService.shortLayoutMode === 'coworking';
        this.isSingleCoworking = () => coworkingService.isSingleCoworking();
        this.isWorkplaceBannerVisible = () => !coworkingService.canUserPublishOffer();

        if (this.isCoworking) {
          const coworkingName = this.ad.coworking.name;

          this.heading = `Коворкинг «${coworkingName}»`;
          this.address = this.ad.coworking.address || this.ad.geo.userInput;
          return;
        }

        const isJKFulfilled =
          this.ad &&                 // объявление инициализировалось
          this.ad.geo.jk &&          // ЖК создан в объекте объявления
          this.ad.geo.jk.name &&     // ЖК привязан (введено имя)
          this.ad.geo.jk.house &&    // корпус ЖК создан в объекте ЖК
          this.ad.geo.jk.house.name; // корпус привязан (введено имя)

        /** Это коммерческая с привязанным ЖК */
        const isBsCenterWithJkPreview = isBsCenterMode && isJKFulfilled;
        /** Это коммерческая без привязки к ЖК */
        const isBsCenterPreview = isBsCenterMode && !isJKFulfilled;
        /** Это новостройка */
        const isJkPreview = addFormLayoutService.shortLayoutMode === 'jk' || isBsCenterWithJkPreview;
        const isBTIPreview = addFormLayoutService.shortLayoutMode === 'bti';

        if (isBsCenterPreview) {
          this.heading = this.ad.building.name;
        } else if (isJkPreview) {
          this.heading = `${this.ad.geo.jk.name} (${this.ad.geo.jk.house.name})`;
        } else if (isBTIPreview) {
          this.heading = this.ad.geo.userInput;
        }

        if (isBsCenterPreview) {
          this.buildingClassType = this.ad.building.classType;
        }

        if (isBsCenterPreview || isBTIPreview) {
          this.year = this.ad.building.buildYear;
        } else if (isJkPreview) {
          const deadline = this.ad.building.deadline;
          if (deadline) {
            const quarter = quartersDict.find(item => item.key === deadline.quarter);
            if (quarter) {
              this.quarter = quarter.numberValue;
            }
            this.year = deadline.year;
          }
        }

        if (isBsCenterPreview) {
          this.totalArea = this.ad.building.totalArea;
        }

        if (isJkPreview) {
          this.developer = this.ad.geo.jk.developer && this.ad.geo.jk.developer.name;
        }

        if (isJkPreview) {
          const material = materialTypeDict.find(item => item.key === this.ad.building.materialType);
          if (material) {
            this.buildingMaterial = material.name;
          }
        }

        this.floors = this.ad.building.floorsCount;
        this.passengerLifts = this.ad.building.passengerLiftsCount || 'нет';
        this.cargoLifts = this.ad.building.cargoLiftsCount || 'нет';

        // Для БТИ адрес передаем как заголовок
        if (addFormLayoutService.shortLayoutMode !== 'bti') {
          this.address = this.ad.geo.userInput;
        }

        this.undergrounds = this.ad.geo.undergrounds.filter(u => u.id).map(underground => ({
          ...underground,
          ...getUndergroundDistance(underground),
        }));

        // TODO переиспользовать фотки из саджеста БЦ или ЖК
        // Сейчас каждый раз фотки загружаются по новой
        // При создании объявления это можно измежать, т.к. у нас есть фотки из данных саджеста
        // eslint-disable-next-line consistent-return
        const photoPromise = $q((resolve, reject) => {
          this.isLoading = true;

          if (isBsCenterPreview) {
            const bsCenterId = get(this.ad, 'businessShoppingCenter.id');

            if (bsCenterId) {
              return apiService.getBsPhoto(bsCenterId)
                .then(result => {
                  const photoUrl = get(result, 'data.thumbnailUrl');
                  resolve(photoUrl);
                }).catch(() => {
                  reject();
                });
            }
          }

          if (isJkPreview) {
            return jkService.getJkPreviewPhoto()
              .then(photoUrl => {
                resolve(photoUrl);
              }).catch(() => {
                reject();
              });
          }

          reject();
        });

        photoPromise
          .then(photoUrl => {
            if (photoUrl) {
              this.photo = photoUrl;
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
      }],
      controllerAs: 'c',
      template,
    };
  }])
  .name;
